<template>
  <DxPopup
    :visible="visible"
    :drag-enabled="false"
    :show-title="true"
    :title="getTitle"
    :show-close-button="true"
    :hide-on-outside-click="true"
    width="60%"
    :height="610"
    @hidden="onClose"
    :wrapperAttr="{ class: 'css-v2 image-preview-popup' }"
    :toolbar-items="toolbarItems"
  >
    <div class="image-preview-body" v-if="file.base64 || file.MediaUrl">
      <img :src="file.base64 || file.MediaUrl" :alt="file.name" height="500" />
    </div>

    <!-- <template #toolbarItems>
      <div class="image-preview-footer">
        <button class="btn" @click="onClose">Back</button>
        <button class="btn primary" @click="download">Download</button>
      </div>
    </template> -->
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";

export default {
  name: "ImagePreviewModal",
  components: {
    DxPopup,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    file: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    getTitle() {
      return this.file && this.file.name
        ? `Image Preview - ${this.file.name}`
        : "Image Preview";
    },
    toolbarItems() {
      return [
        {
          widget: "dxButton",
          toolbar: "bottom", // 👈 Put this in footer
          location: "before",
          options: {
            text: "Back",
            type: "normal",
            stylingMode: "text",
            onClick: this.onClose,
          },
        },
        {
          widget: "dxButton",
          toolbar: "bottom", // 👈 Put this in footer
          location: "after",
          options: {
            text: "Download",
            type: "default",
            stylingMode: "contained",
            onClick: this.download,
          },
        },
      ];
    },
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    download() {
      if (this.file.DownloadApiUrl) {
        var blobUrl = this.file.DownloadApiUrl;
        this.$emit("showLoading", true);
        fetch(blobUrl)
          .then((response) => response.blob())
          .then((blob) => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download =
              this.file.name || "download-" + new Date().getTime(); // You can set a filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            this.$emit("showLoading", false);
          })
          .catch(() => {
            this.$emit("showLoading", false);
          });
      } else {
        const link = document.createElement("a");
        link.href = this.file.base64;
        link.download = this.file.name || "image";
        link.click();
      }
    },
  },
};
</script>

<style lang="scss">
.image-preview-popup {
  .dx-popup-content {
    padding: 0 !important;

    .image-preview-body {
      padding: 16px;
      text-align: center;
      background: #fff;

      img {
        max-width: 100%;
        // height: auto;
        border-radius: 6px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      }
    }

    .image-preview-footer {
      display: flex;
      justify-content: space-between;
      padding: 12px 16px;
      border-top: 1px solid #e0e0e0;
      background: #f9f9f9;

      .btn {
        padding: 6px 16px;
        font-size: 14px;
        cursor: pointer;
        border: none;
        background: transparent;
        color: #2a95c5;
      }

      .btn.primary {
        background: #2a95c5;
        color: #fff;
        border-radius: 4px;
      }
    }
  }

  .dx-toolbar.dx-popup-bottom {
    .dx-button .dx-button-content {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .dx-toolbar-before {
      .dx-button {
        width: 268px;
        height: 36px;
        padding-top: spacing-md;
        padding-right: spacing-lg;
        padding-bottom: spacing-md;
        padding-left: spacing-lg;
        gap: 4;
        angle: 0 deg;
        opacity: 1;
        border-radius: radius-none;
        border-width: 1px;

        background: var(
          --Component-colors-Components-Buttons-Secondary-button-secondary-bg,
          #ffffff
        );
        border: 1px solid
          var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-border,
            #d0d5dd
          );
        box-shadow: 0px 1px 2px 0px #1018280d;
      }
    }

    .dx-toolbar-after {
      .dx-button {
        width: 268px;
        height: 36px;
        padding-top: spacing-md;
        padding-right: spacing-lg;
        padding-bottom: spacing-md;
        padding-left: spacing-lg;
        gap: 4;
        angle: 0 deg;
        opacity: 1;
        border-radius: radius-none;
        border-width: 1px;

        background: var(
          --Component-colors-Components-Buttons-Primary-button-primary-bg,
          #35baf6
        );
        border: 1px solid #2a95c5;
        box-shadow: 0px 1px 2px 0px #1018280d;
      }
    }
  }
}
</style>
